import { drawCoordinates, drawLineCoordinates } from "./drawFunctions";

function handleRemoveItem(
  id,
  items,
  setItems,
  tableData,
  setTableData,
  canvas,
  editMode,
  itemBeingEdited,
  drawMode
) {
  const new_items = items.filter((item) => item.id !== id);
  setItems(new_items);

  if (tableData.find((data) => data.key === id)) {
    const new_table_data = tableData.filter((data) => data.key !== id);
    setTableData(new_table_data);
  }

  if (drawMode === "zone") {
    drawCoordinates(
      canvas.getContext("2d"),
      new_items,
      editMode,
      itemBeingEdited,
      canvas
    );
  } else if (drawMode === "line") {
    drawLineCoordinates(
      canvas.getContext("2d"),
      new_items,
      editMode,
      itemBeingEdited,
      canvas
    );
  }
}

export { handleRemoveItem };
